import"./Tabs.css.ts.vanilla.css";var o="_1p7ov1s0",p="_1p7ov1s1";export{o as container,p as ul};
